import LegalPage from "@/pages/LegalPage";
import { PRIVACY_MARKDOWN } from "@/content/privacy";

export default function Privacy() {
  return <LegalPage title="Privacy Policy" markdown={PRIVACY_MARKDOWN} testId="privacy-page" />;
}
